module.exports = __webpack_public_path__ + "static/media/WhatwedoImg1.48c00510.png";